/* ============================================================
   BLANC CERISE — LP multi-univers · ajout au panier des cartes LP
   Même mécanique que <quick-add-variant> du thème : POST JSON sur cart_add_url
   en demandant le rendu des sections du tiroir panier (apt-cart-drawer) et du
   compteur (apt-cart-counter), puis ouverture du tiroir.
   Sans tiroir sur la page : redirection vers le panier.
   ============================================================ */
(function () {
  if (window.__lpuCart) return;
  window.__lpuCart = true;

  var ADDED_MS = 2600;

  function setError(form, message) {
    var box = form.querySelector('.lpu-card__error');
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  }

  function add(form) {
    var button = form.querySelector('button[type="submit"]');
    var idField = form.querySelector('[name="id"]');
    if (!button || !idField || !idField.value || button.classList.contains('is-loading')) return;

    var drawer = document.querySelector('apt-cart-drawer');
    var counter = document.querySelector('apt-cart-counter');
    var sections = [];
    if (drawer && drawer.sectionId) sections.push(drawer.sectionId);
    if (counter && counter.sectionId) sections.push(counter.sectionId);

    setError(form, '');
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(idField.value), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data || {};
        // Shopify répond { status, message, description } en cas de refus (stock, quantité…)
        if (!result.ok || data.status) {
          throw new Error(data.description || data.message || 'Ajout impossible pour le moment.');
        }

        if (drawer) {
          if (data.sections && data.sections[drawer.sectionId] && drawer.refreshContentWithHtml) {
            drawer.refreshContentWithHtml(data.sections[drawer.sectionId], true);
          } else if (drawer.refresh) {
            drawer.refresh();
            if (drawer.open) drawer.open();
          }
        }
        if (counter) {
          if (data.sections && data.sections[counter.sectionId] && counter.refreshContentWithHtml) {
            counter.refreshContentWithHtml(data.sections[counter.sectionId]);
          } else if (counter.refresh) {
            counter.refresh();
          }
        }
        if (!drawer) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        button.classList.add('is-added');
        button.textContent = button.getAttribute('data-label-added') || 'Ajouté ✓';
        window.setTimeout(function () {
          button.classList.remove('is-added');
          button.textContent = button.getAttribute('data-label-add') || 'Ajouter au panier';
        }, ADDED_MS);
      })
      .catch(function (error) {
        setError(form, error && error.message ? error.message : 'Ajout impossible pour le moment.');
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-lpu-add]')) return;
    if (!window.fetch) return; // vieux navigateurs : envoi classique du formulaire
    event.preventDefault();
    add(form);
  });

  // Changer de variante efface un éventuel message d'erreur
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('form[data-lpu-add] select[name="id"]')) return;
    setError(select.form, '');
  });
})();
